import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({

  routes: [
    {
      path: '/',
      redirect: '/Index'
  },
    {
      path: "/Index",
      name: "Index",
      meta: {
          title: '首页'
      },
      component: () => import ("@/views/Index/Index.vue")
  },
  {
    path: "/Introduction",
    name: "Introduction",
    meta: {
        title: '企业介绍'
    },
    component: () => import ("@/views/Introduction/Introduction.vue")
},
{
  path: "/Founder",
  name: "Founder",
  meta: {
      title: '创始人'
  },
  component: () => import ("@/views/Founder/Founder.vue")
},
{
  path: "/News",
  name: "News",
  meta: {
      title: '新闻中心'
  },
  component: () => import ("@/views/News/News.vue")
},
{
  path: "/NewsDetail",
  name: "NewsDetail",
  meta: {
      title: '新闻详情01'
  },
  component: () => import ("@/views/NewsDetail/NewsDetail.vue")
},
{
  path: "/Detail2",
  name: "Detail2",
  meta: {
      title: '新闻详情02'
  },
  component: () => import ("@/views/NewsDetail/Detail02.vue")
},
{
  path: "/Detail3",
  name: "Detail3",
  meta: {
      title: '新闻详情03'
  },
  component: () => import ("@/views/NewsDetail/Detail03.vue")
},
{
  path: "/Detail4",
  name: "Detail4",
  meta: {
      title: '新闻详情04'
  },
  component: () => import ("@/views/NewsDetail/Detail04.vue")
},
{
  path: "/Detail6",
  name: "Detail6",
  meta: {
      title: '新闻详情06'
  },
  component: () => import ("@/views/NewsDetail/Detail06.vue")
},
{
  path: "/Detail7",
  name: "Detail7",
  meta: {
      title: '新闻详情07'
  },
  component: () => import ("@/views/NewsDetail/Detail07.vue")
},
{
  path: "/Detail8",
  name: "Detail8",
  meta: {
      title: '新闻详情08'
  },
  component: () => import ("@/views/NewsDetail/Detail08.vue")
},
{
  path: "/Detail9",
  name: "Detail9",
  meta: {
      title: '新闻详情09'
  },
  component: () => import ("@/views/NewsDetail/Detail09.vue")
},
{
  path: "/Detail10",
  name: "Detail10",
  meta: {
      title: '新闻详情10'
  },
  component: () => import ("@/views/NewsDetail/Detail10.vue")
},{
  path: "/Detail11",
  name: "Detail11",
  meta: {
      title: '新闻详情11'
  },
  component: () => import ("@/views/NewsDetail/Detail11.vue")
},
{
  path: "/Detail12",
  name: "Detail12",
  meta: {
      title: '新闻详情12'
  },
  component: () => import ("@/views/NewsDetail/Detail12.vue")
},
{
  path: "/Detail13",
  name: "Detail13",
  meta: {
      title: '新闻详情13'
  },
  component: () => import ("@/views/NewsDetail/Detail13.vue")
},
{
  path: "/Detail14",
  name: "Detail14",
  meta: {
      title: '新闻详情14'
  },
  component: () => import ("@/views/NewsDetail/Detail14.vue")
},
{
  path: "/Detail15",
  name: "Detail15",
  meta: {
      title: '新闻详情15'
  },
  component: () => import ("@/views/NewsDetail/Detail15.vue")
},

{
  path: "/Detail16",
  name: "Detail16",
  meta: {
      title: '新闻详情16'
  },
  component: () => import ("@/views/NewsDetail/Detail16.vue")
},
{
  path: "/Detail17",
  name: "Detail17",
  meta: {
      title: '新闻详情16'
  },
  component: () => import ("@/views/NewsDetail/Detail17.vue")
},
{
  path: "/Detail18",
  name: "Detail18",
  meta: {
      title: '新闻详情18'
  },
  component: () => import ("@/views/NewsDetail/Detail18.vue")
},
{
  path: "/Detail20",
  name: "Detail20",
  meta: {
      title: '新闻详情20'
  },
  component: () => import ("@/views/NewsDetail/Detail20.vue")
},
{
  path: "/Detail19",
  name: "Detail19",
  meta: {
      title: '新闻详情19'
  },
  component: () => import ("@/views/NewsDetail/Detail19.vue")
},
{
  path: "/Detail21",
  name: "Detail21",
  meta: {
      title: '新闻详情21'
  },
  component: () => import ("@/views/NewsDetail/Detail21.vue")
},
{
  path: "/Detail22",
  name: "Detail22",
  meta: {
      title: '新闻详情22'
  },
  component: () => import ("@/views/NewsDetail/Detail22.vue")
},
{
  path: "/Detail23",
  name: "Detail23",
  meta: {
      title: '新闻详情23'
  },
  component: () => import ("@/views/NewsDetail/Detail23.vue")
},
{
  path: "/Detail24",
  name: "Detail24",
  meta: {
      title: '新闻详情24'
  },
  component: () => import ("@/views/NewsDetail/Detail24.vue")
},
{
  path: "/Detail25",
  name: "Detail25",
  meta: {
      title: '新闻详情25'
  },
  component: () => import ("@/views/NewsDetail/Detail25.vue")
},
{
  path: "/Detail26",
  name: "Detail26",
  meta: {
      title: '新闻详情26'
  },
  component: () => import ("@/views/NewsDetail/Detail26.vue")
},
{
  path: "/Detail27",
  name: "Detail27",
  meta: {
      title: '新闻详情26'
  },
  component: () => import ("@/views/NewsDetail/Detail27.vue")
},
{
  path: "/Detail28",
  name: "Detail28",
  meta: {
      title: '新闻详情28'
  },
  component: () => import ("@/views/NewsDetail/Detail28.vue")
},
{
  path: "/Detail29",
  name: "Detail29",
  meta: {
      title: '新闻详情29'
  },
  component: () => import ("@/views/NewsDetail/Detail29.vue")
},
{
  path: "/Detail30",
  name: "Detail30",
  meta: {
      title: '新闻详情29'
  },
  component: () => import ("@/views/NewsDetail/Detail30.vue")
},
{
  path: "/Detail31",
  name: "Detail31",
  meta: {
      title: '新闻详情31'
  },
  component: () => import ("@/views/NewsDetail/Detail31.vue")
},
{
  path: "/Detail32",
  name: "Detail32",
  meta: {
      title: '新闻详情32'
  },
  component: () => import ("@/views/NewsDetail/Detail32.vue")
},
{
  path: "/Detail33",
  name: "Detail33",
  meta: {
      title: '新闻详情33'
  },
  component: () => import ("@/views/NewsDetail/Detail33.vue")
},
{
  path: "/Detail34",
  name: "Detail34",
  meta: {
      title: '新闻详情34'
  },
  component: () => import ("@/views/NewsDetail/Detail34.vue")
},
{
  path: "/Detail35",
  name: "Detail35",
  meta: {
      title: '新闻详情35'
  },
  component: () => import ("@/views/NewsDetail/Detail35.vue")
},
{
  path: "/Detail36",
  name: "Detail36",
  meta: {
      title: '新闻详情36'
  },
  component: () => import ("@/views/NewsDetail/Detail36.vue")
},
{
  path: "/Detail37",
  name: "Detail37",
  meta: {
      title: '新闻详情37'
  },
  component: () => import ("../views/NewsDetail/Detail37.vue")
},
{
  path: "/Detail38",
  name: "Detail38",
  meta: {
      title: '新闻详情38'
  },
  component: () => import ("../views/NewsDetail/Detail38.vue")
},
{
  path: "/Detail39",
  name: "Detail39",
  meta: {
      title: '新闻详情39'
  },
  component: () => import ("../views/NewsDetail/Detail39.vue")
},
{
  path: "/Detail40",
  name: "Detail40",
  meta: {
      title: '新闻详情40'
  },
  component: () => import ("../views/NewsDetail/Detail40.vue")
},
{
  path: "/Detail41",
  name: "Detail41",
  meta: {
      title: '新闻详情41'
  },
  component: () => import ("../views/NewsDetail/Detail41.vue")
},
{
  path: "/Publication",
  name: "Publication",
  meta: {
      title: '出版物'
  },
  component: () => import ("@/views/Publication/Publication.vue")
},
{
  path: '/pdf',
  name: 'pdf',
  component: () => import ("@/views/Publication/pdf.vue")
},
{
  path: "/ProductLine",
  name: "ProductLine",
  meta: {
      title: '技术与产品'
  },
  component: () => import ("@/views/ProductLine/ProductLine")
},
{
  path: "/ContactUs",
  name: "ContactUs",
  meta: {
      title: '联系我们'
  },
  component: () => import ("@/views/ContactUs/ContactUs.vue")
},
{
  path: "/JoinUs",
  name: "JoinUs",
  meta: {
      title: '加入我们'
  },
  component: () => import ("@/views/JoinUs/JoinUs.vue")
},
{
  path: "/JoinDetails",
  name: "JoinDetails",
  meta: {
      title: '加入我们详情'
  },
  component: () => import ("@/views/JoinDetails/JoinDetails.vue")
},
{
  path: "/Technological",
  name: "Technological",
  meta: {
      title: '技术创新'
  },
  component: () => import ("@/views/Technological/Technological.vue")
},
  {
    path: "/About",
    name: "About",
    meta: {
        title: '关于我们'
    },
    component: () => import ("@/views/About/About.vue")
},
{
  path: "/Trade",
  name: "Trade",
  meta: {
      title: '行业资讯'
  },
  component: () => import ("@/views/Trade/Trade.vue")
},
{
  path: "/Trade02",
  name: "Trade02",
  meta: {
      title: '行业资讯'
  },
  component: () => import ("@/views/Trade/Trade02.vue")
},
{
  path: "/Trade03",
  name: "Trade03",
  meta: {
      title: '行业资讯'
  },
  component: () => import ("@/views/Trade/Trade03.vue")
},


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js